import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const COLLECTION_HANDLE = 'gift-collection-test-1';

const actions = {
    getProducts(context) {
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
        .then(response => response.data)
        .then((data) => {
          // Figure out how many pages of data we have to pull
          const numOfPages = Math.ceil(data.collection.products_count / 250);
          fetchProducts(numOfPages, []);
        })
        .catch((err) => {
          console.log('***Error Fetching NumOfProducts***');
        });
    
        function fetchProducts(pageNum, productList) {
          // Recursive function that gets the full list of products
          if (pageNum != 0) {
            axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${pageNum}`)
              .then(response => response.data)
              .then((data) => {
                const updatedProductList = [...data.products, ...productList];
                fetchProducts(pageNum - 1, updatedProductList);
              })
              .catch((err) => {
                console.log('***Error Fetching Products***');
              });
          } else {
            sortFetchedProducts(productList);
          }
        }
    
        async function sortFetchedProducts(totalProductList) {
          let i = 1;
          let pullcollections = true;
          let collectionList = [];
          while(pullcollections){
            let collections = await axios.get(`/collections.json?limit=250&page=${i}`);
            if(collections && collections.data && collections.data.collections && collections.data.collections.length > 0){
              collectionList = collectionList.concat(collections.data.collections);
              i++
              if(collections.data.collections.length != 250){
                pullcollections = false;
              }
            }
            else {
              pullcollections = false;
            }
          }
          var giftCollections = totalProductList;
          context.commit('setGiftCollections', giftCollections);
          let collectionsSaved = [];
          for (let collection of giftCollections){
            let metafields = await axios.get(`/collections/${collection.handle}?view=metafields`);
            let related_collections = [];
            let value = 0;
            let category = "";
            if(metafields 
              && metafields.data 
              && metafields.data.metafields 
            ){
              if(metafields.data.metafields.related_collections && metafields.data.metafields.related_collections.length > 0){
                related_collections = metafields.data.metafields.related_collections.map((x) => {
                  const splitted = x.split("/");
                  return splitted[splitted.length - 1];
                })
              }
              if(metafields.data.metafields.value && metafields.data.metafields.value > 0)
                value = metafields.data.metafields.value;
              if(metafields.data.metafields.GOC_CATEGORY && metafields.data.metafields.GOC_CATEGORY != "")
                category = metafields.data.metafields.GOC_CATEGORY;
            }
            let collectionHandle = collection.body_html;
            let currentCollection = collectionsSaved.find(x => x.collectionHandle == collectionHandle)
            let collectionProducts = [];
            if(currentCollection){
              collectionProducts = currentCollection.products;
            }
            else {
              let response = await axios.get(`/collections/${collectionHandle}/products.json?limit=250`);
              collectionProducts = response.data.products;
              collectionsSaved.push({collectionHandle:collectionHandle,products: response.data.products});
            }
            for(let id of related_collections){
              let collection = collectionList.find(x => x.id == id);
              if(collection){
                let metaCollection = collectionsSaved.find(x => x.collectionHandle == collection.handle);
                if(metaCollection){
                  collectionProducts = collectionProducts.concat(metaCollection.products);
                }
                else {
                  let productResponse = await axios.get(`/collections/${collection.handle}/products.json?limit=250`);
                  if(productResponse.data.products.length > 0){
                    productResponse = productResponse.data.products;
                    collectionProducts = collectionProducts.concat(productResponse);
                    collectionsSaved.push({collectionHandle:collection.handle,products: productResponse});
                  }
                }
              }
            }
            context.commit('updateGiftCollection', {id: collection.id,products:collectionProducts,value: value, category:category});
          }
        }
      },
};

export default actions;
